import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { Toast, ToastController, ViewController } from "ionic-angular";

import { ConfigService } from "../../services/config.service";
import { WalletService } from "../../services/wallet.service";

@Component({
  selector: "page-receiveautographs",
  templateUrl: "receiveautographs.html"
})
export class ReceiveautographsPage {
  address: string;
  public toast: Toast;

  constructor(
    private toastCtrl: ToastController,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private walletService: WalletService
  ) {
    this.address = this.walletService.getAddress();
    this.toast = this.toastCtrl.create({
      message: "Dirección copiada en el portapapeles",
      duration: 3000
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad ReceiveautographsPage");
  }

  ionViewWillEnter() {}

  onCopy() {
    this.toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/receiveautographs/receiveautographs.ts